import { useFormik } from "formik";
import * as yup from "yup";
import TextInput from "../../../../../components/inputs/textInput";
import Button from "../../../../../components/buttons/button";
import DateInput from "../../../../../components/inputs/dateInput";
import { useOptions } from "../../../../../components/hooks/useOptionsHook";
import Select from "../../../../../components/select/select";

const EntitlementAdd = ({ t, setOpen }) => {
  const validationSchema = yup.object({
    employee: yup.string().required(t("required")),
    entitlementType: yup.string().required(t("required")),
    amount: yup.string().required(t("required")),
    reason: yup.string().required(t("required")),
    date: yup.string().required(t("required")),
  });
  const formik = useFormik({
    initialValues: {
      employee: "",
      entitlementType: "",
      amount: "",
      reason: "",
      date: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values);
      setOpen(false);
    },
  });
  const { memberShipTypeOptions, addSalaryOptions } = useOptions();

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <div>
        <Select
          options={memberShipTypeOptions}
          formik={formik}
          name={"entitlementType"}
          label={t("entitlementType")}
          placeholder={t("entitlementType")}
        />
      </div>
      <div className="inputs">
        <Select
          options={addSalaryOptions}
          formik={formik}
          name={"employee"}
          label={t("employee")}
          placeholder={t("employee")}
        />
      </div>
      <div className="inputs">
        <TextInput
          placeholder={t("enterReason")}
          formik={formik}
          name={"reason"}
          label={t("reason")}
        />
      </div>
      <div className="inputs">
        <TextInput
          placeholder={t("enterAmount")}
          formik={formik}
          name={"amount"}
          label={t("amount")}
        />
      </div>

      <div className="inputs">
        <DateInput
          placeholder={"yyyy/mm/dd"}
          formik={formik}
          label={t("date")}
          name={"date"}
        />
      </div>

      <div className="flex items-center justify-end gap-3">
        <Button className={"bg-primary justify-center w-[130px] text-black text-sm"}>
          {t("add")}
        </Button>
        <Button
          className={"border border-[#C42E27] text-[#C42E27] text-sm"}
          type="button"
          onClick={() => setOpen(false)}
        >
          {t("cancel")}
        </Button>
      </div>
    </form>
  );
};

export default EntitlementAdd;
